const clients = [
  { name: "NEXATECH", style: "font-black tracking-widest text-sm uppercase" },
  { name: "GlobalMart", style: "font-light tracking-wide text-base" },
  { name: "HORIZON CO.", style: "font-bold tracking-[0.2em] text-xs uppercase" },
  { name: "MeridaCo", style: "font-semibold italic tracking-tight text-base" },
  { name: "PacificTrade", style: "font-medium tracking-normal text-sm" },
  { name: "VertexGroup", style: "font-extrabold tracking-tight text-sm" },
  { name: "ClearPath", style: "font-light tracking-widest text-sm uppercase" },
  { name: "SUMMIT RETAIL", style: "font-bold tracking-[0.15em] text-xs uppercase" },
];

const badges = [
  {
    icon: "ri-group-line",
    value: "50+",
    label: "Verified Suppliers",
  },
  {
    icon: "ri-earth-line",
    value: "8+",
    label: "Countries Reached",
  },
  {
    icon: "ri-shield-check-line",
    value: "Vetted",
    label: "Supplier Network",
  },
  {
    icon: "ri-lock-2-line",
    value: "Secure",
    label: "Transactions",
  },
  {
    icon: "ri-star-line",
    value: "4.8 / 5",
    label: "Client Rating",
  },
];

export default function TrustSection() {
  return (
    <section className="bg-white border-b border-[#D9E2EC]">

      {/* Client Logos Strip */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-12 pb-8">
        <p className="text-center text-xs font-semibold uppercase tracking-widest text-[#3A506B]/50 mb-8">
          Trusted by 75+ businesses across all three pillars
        </p>
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-5">
          {clients.map((c) => (
            <span
              key={c.name}
              className={`${c.style} text-[#3A506B]/30 hover:text-[#3A506B]/55 transition-colors duration-200 select-none whitespace-nowrap`}
            >
              {c.name}
            </span>
          ))}
        </div>
      </div>

      {/* Divider */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="h-px bg-[#D9E2EC]" />
      </div>

      {/* Trust Badges Strip */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-7">
        <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {badges.map((b, i) => (
            <>
              <div key={b.label} className="flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#C9A227]/10">
                  <i className={`${b.icon} text-[#C9A227] text-base`}></i>
                </div>
                <div>
                  <p className="text-xs font-extrabold text-[#222831] leading-tight">{b.value}</p>
                  <p className="text-xs text-[#3A506B]/70 leading-tight">{b.label}</p>
                </div>
              </div>
              {i < badges.length - 1 && (
                <div key={`sep-${i}`} className="hidden md:block h-6 w-px bg-[#D9E2EC]" />
              )}
            </>
          ))}
        </div>
      </div>

    </section>
  );
}
